module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/10811a978de201353d564df7ba1ddb58.svg";